// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#login-container {
  /* visited link */
  /* mouse over link */
  /* selected link */
}
#login-container .hover-dj-blue:hover {
  color: #008CCE;
}
#login-container a:link {
  color: #008CCE;
}
#login-container a:visited {
  color: #008CCE;
}
#login-container a:hover {
  color: #008CCE;
}
#login-container a:active {
  color: #008CCE;
}
#login-container input[type=checkbox] {
  accent-color: #008CCE;
}
#login-container .google-button-styles {
  border: 2px solid #008CCE !important;
  border-radius: 4px !important;
  color: #008CCE !important;
  max-height: 42px;
}
@media (max-width: 599px) {
  #login-container .google-button-styles div {
    border-color: #008CCE !important;
    border-style: solid !important;
    border-width: 1px 0px 2px 0 !important;
    border-radius: 2px 0px 0px 2px !important;
    padding: 8px 8px 9px 8px !important;
  }
}
@media (max-width: 1499px) {
  #login-container .google-button-styles div {
    border-color: #008CCE !important;
    border-style: solid !important;
    border-width: 2px 0px 2px 0 !important;
    border-radius: 2px 0px 0px 2px !important;
    padding: 8px 8px 9px 8px !important;
  }
}
@media (min-width: 1500px) {
  #login-container .google-button-styles div {
    border-color: #008CCE !important;
    border-style: solid !important;
    border-width: 1px 0px 2px 0 !important;
    border-radius: 2px 0px 0px 2px !important;
    padding: 8px 8px 9px 8px !important;
  }
}
@media (max-width: 599px) {
  #login-container .button-container {
    padding-bottom: 10px;
  }
}
#login-container .alice-carousel__dots-item:not(.__custom) {
  width: 20px;
  height: 20px;
  cursor: pointer;
  border-radius: 50%;
  background-color: transparent;
  border: 2px solid white;
}
#login-container .alice-carousel__dots-item:not(.__custom):hover, #login-container .alice-carousel__dots-item:not(.__custom).__active {
  background-color: white;
}
#login-container .alice-carousel__prev-btn, #login-container .alice-carousel__next-btn {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/login/login.scss"],"names":[],"mappings":"AAEA;EASA,iBAAA;EAKA,oBAAA;EAKA,kBAAA;AAjBA;AADA;EACC,cAJS;AAOV;AAAA;EACE,cARQ;AAUV;AAEA;EACE,cAbQ;AAaV;AAIA;EACE,cAlBQ;AAgBV;AAMA;EACE,cAvBQ;AAmBV;AAOA;EACC,qBA3BS;AAsBV;AAQA;EACC,oCAAA;EACA,6BAAA;EACA,yBAAA;EACA,gBAAA;AAND;AAUC;EADD;IAEE,gCAAA;IACA,8BAAA;IACA,sCAAA;IACA,yCAAA;IACA,mCAAA;EAPA;AACF;AAQC;EARD;IASE,gCAAA;IACA,8BAAA;IACA,sCAAA;IACA,yCAAA;IACA,mCAAA;EALA;AACF;AAMC;EAfD;IAgBE,gCAAA;IACA,8BAAA;IACA,sCAAA;IACA,yCAAA;IACA,mCAAA;EAHA;AACF;AAQC;EADD;IAEE,oBAAA;EALA;AACF;AAQA;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;AAND;AASA;EACC,uBAAA;AAPD;AAUA;EACC,aAAA;AARD","sourcesContent":["$dj-blue: #008CCE;\n\n#login-container{\n.hover-dj-blue:hover {\n color: $dj-blue;\n}\n\na:link {\n  color: $dj-blue;\n}\n\n/* visited link */\na:visited {\n  color: $dj-blue;\n}\n\n/* mouse over link */\na:hover {\n  color: $dj-blue;\n}\n\n/* selected link */\na:active {\n  color: $dj-blue;\n}\n\ninput[type='checkbox'] {\n\taccent-color: $dj-blue;\n}\n\n.google-button-styles {\n\tborder: 2px solid $dj-blue !important;\n\tborder-radius: 4px !important;\n\tcolor: $dj-blue !important;\n\tmax-height: 42px;\n}\n\n.google-button-styles div {\n\t@media (max-width: 599px) {\n\t\tborder-color: $dj-blue !important;\n\t\tborder-style: solid !important;\n\t\tborder-width: 1px 0px 2px 0 !important;\n\t\tborder-radius: 2px 0px 0px 2px !important;\n\t\tpadding: 8px 8px 9px 8px !important;\n\t}\n\t@media (max-width: 1499px) {\n\t\tborder-color: $dj-blue !important;\n\t\tborder-style: solid !important;\n\t\tborder-width: 2px 0px 2px 0 !important;\n\t\tborder-radius: 2px 0px 0px 2px !important;\n\t\tpadding: 8px 8px 9px 8px !important;\n\t}\n\t@media (min-width: 1500px) {\n\t\tborder-color: $dj-blue !important;\n\t\tborder-style: solid !important;\n\t\tborder-width: 1px 0px 2px 0 !important;\n\t\tborder-radius: 2px 0px 0px 2px !important;\n\t\tpadding: 8px 8px 9px 8px !important;\n\t}\n\n}\n\n.button-container {\n\t@media (max-width: 599px) {\n\t\tpadding-bottom: 10px;\n\t}\n}\n\n.alice-carousel__dots-item:not(.__custom) {\n\twidth: 20px;\n\theight: 20px;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\tbackground-color: transparent;\n\tborder: 2px solid white;\n}\n\n.alice-carousel__dots-item:not(.__custom):hover, .alice-carousel__dots-item:not(.__custom).__active {\n\tbackground-color: white;\n}\n\n.alice-carousel__prev-btn, .alice-carousel__next-btn {\n\tdisplay: none;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
